import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VAutocomplete,{attrs:{"outlined":"","multiple":"","deletable-chips":"","chips":"","clearable":"","items":_vm.keys,"label":"Rechercher parmi les clés...","prepend-inner-icon":"search"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }